import { computed } from "vue"
import { defineComponent, type Popup, type ReactiveComponent } from "vue-utils"
import { usePopups } from "../composition/usePopups"
import Modal from "./Modal"

const Popups: ReactiveComponent = () => {
	const popups = usePopups()
	const popup = computed(() => (popups.popups.value.length === 0 ? null : popups.popups.value[popups.popups.value.length - 1]))

	return () => {
		if (!popup.value) {
			return null
		}
		const Content = popup.value.content
		return (
			<Modal
				zIndex={4}
				style={{
					minWidth: `min(${popup.value.width ?? "30rem"}, calc(100vw - 4rem))`,
					width: popup.value.width ?? "22.5%",
				}}
				onCancel={(e) => {
					e.preventDefault()
					if (popup.value && popup.value.closable) {
						popup.value.onClose?.()
						popups.closePopup(popup.value)
					}
				}}
			>
				<Content close={() => popups.closePopup(popup.value as Popup)} popup={popup.value} />
			</Modal>
		)
	}
}

export default defineComponent(Popups)
